(function () {
    const querystring = document.location.search;
    const params = new URLSearchParams(querystring);
    const message = params.get('message') ?? '';
    const product_url = params.get('product_url') ?? '';

    if (message) {
        document.querySelector('.contact__textarea').value = message.replace(/<\/?[^>]+(>|$)/g, "");
    }

    if (product_url) {
        document.querySelector('#form_field_product_url').value = product_url.replace(/<\/?[^>]+(>|$)/g, "");
    }
})();
